import { Outlet } from 'react-router-dom';
import { Box, Container, Typography, Paper } from '@mui/material';
import { MedicalServices as DentistIcon } from '@mui/icons-material';

export default function AuthLayout() {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #0891b2 0%, #0e7490 100%)',
        p: 2,
      }}
    >
      <Container maxWidth="sm">
        <Paper
          elevation={6}
          sx={{
            p: 4,
            borderRadius: 3,
            backgroundColor: 'rgba(255, 255, 255, 0.98)',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              mb: 4,
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                mb: 1,
              }}
            >
              <DentistIcon color="primary" sx={{ fontSize: 40 }} />
              <Typography variant="h4" color="primary" fontWeight="bold">
                CRM Odonto
              </Typography>
            </Box>
            <Typography variant="body2" color="text.secondary">
              Sistema de Gestão para Consultório Odontológico
            </Typography>
          </Box>
          <Outlet />
        </Paper>
        <Typography
          variant="caption"
          color="white"
          sx={{
            display: 'block',
            textAlign: 'center',
            mt: 3,
            opacity: 0.8,
          }}
        >
          © {new Date().getFullYear()} CRM Odonto. Todos os direitos reservados.
        </Typography>
      </Container>
    </Box>
  );
}
